import { Shape, ShapeOptions } from "../Shape";
import { SVGParsedPathData } from "../../../svg/";
import { YZCanvasContext } from "../canvas";
import { toRadian } from "@zyzgroup/core-common";

export type StarShapeOptions = {
  starR?: number;
} & ShapeOptions;

export class StarShape extends Shape {
  r: number;

  constructor(options?: StarShapeOptions) {
    super(options);
    this.r = options?.starR || 20;
  }

  protected cloneShape(): StarShape {
    const shape = new StarShape({
      ...super.getBaseOptions(),
      starR: this.r
    });
    return shape;
  }

  public toSVGPathData(): SVGParsedPathData[] {
    const data: SVGParsedPathData[] = [["m", 0, -this.r]];
    for (let c = 0; c < 6; c += 1) {
      /// +18 摆正 StarShape
      const degree = 18 + 270 + c * 144;
      const rx = this.r * Math.cos(toRadian(degree));
      const ry = this.r * Math.sin(toRadian(degree));
      data.push(["l", rx, ry]);
    }
    return data;
  }
}

export default StarShape;
